import { ComponentRef, Injectable, Renderer2, RendererFactory2, ViewContainerRef } from "@angular/core";
import { firstValueFrom, Observable, Subject, Subscription } from "rxjs";
import { MatDialog } from "@angular/material/dialog";
import { RouteSheetLocationDTO } from "../models/RouteSheetLocationDTO";
import { MapHelperService } from "src/services/map-helper.service";
import { environment } from "src/environments/environment";
import mapboxgl from "mapbox-gl";
import { CarouselComponent } from "src/app/features/ui/molecules/carousel/carousel.component";
import { LocationCategoryDTO } from "src/app/features/map-features/sections/locations-section/models/LocationCategoryDTO";
import { NameToSingularPipe } from "src/app/features/shared/pipes/NameToSingular.pipe";
import { LocalStorageService } from "src/app/features/shared/services/LocalStorage.service";
import { EnumLocationCategories } from "src/app/features/shared/helpers/enums/EnumLocationCategories";
import { ServiceLocationDetailPopupComponent } from "src/app/features/map-features/sections/locations-section/components/3-panel-detail-locations/organisms/location-popup-details/service-location-detail-popup/service-location-detail-popup.component";
import { LocationsLocationDetailPopupComponent } from "src/app/features/map-features/sections/locations-section/components/3-panel-detail-locations/organisms/location-popup-details/locations-location-detail-popup/locations-location-detail-popup.component";
import { ProspectDetailsPopupComponent } from "src/app/features/map-features/sections/locations-section/components/3-panel-detail-locations/organisms/location-popup-details/prospect-details-popup/prospect-details-popup.component";
import { GeneralLocationsDetailsPopUpComponent } from "src/app/features/map-features/sections/locations-section/components/3-panel-detail-locations/organisms/location-popup-details/general-location-detail-popup/general-location-details-popup.component";


@Injectable({
  providedIn: "root",
})
export class RouteSheetUtilService{
  //variables para crear un componente dinamicamente (estas son para el carrusel del popup)
  private carouselViewContainerRef: ViewContainerRef;
  private renderer: Renderer2;
  
  //variables para iconos
  routeSheetMapIconSize: number = 0.1011;

  routeSheetClusterMaxZoom: number = 16;
  routeSheetClusterRadius: number = 60;

  SourcePrefix: string = "routeSheetLocationsSource-";
  LayerPrefix: string = "layer-RouteSheetLocations-";

  routeSourcePrefix: string = "routeSheetRouteSource-";
  routeLayerPrefix: string = "layer-RouteSheetRoute-";

  loadedLocationCategories: Record<string, LocationCategoryDTO> = {};

  public isLoadingList: boolean = false;

  //para panel related details como popup
  public dialogDetailsRef: any = null;
  keys: string[] = [];
  values: string[] = [];
  arrayMaster: any[] = [];
  images: string[] = [];

  location_details_subscription: Subscription;
  location_route_subscription: Subscription;

  constructor(
    private mapHelperService: MapHelperService,
    private nameToSingularPipe: NameToSingularPipe,
    private rendererFactory: RendererFactory2,
    private localStorageService: LocalStorageService, 
    private dialog: MatDialog,
    ) 
    {
      this.renderer = this.rendererFactory.createRenderer(null, null);
    }

    public setCarouselViewContainerRef(vcr: ViewContainerRef) {
      this.carouselViewContainerRef = vcr;
    }

  // setRouteFromFirstLocationToParent(routeSheetLocation: RouteSheetLocationDTO): void {
  //     this.location_route_subscription = this.locationService.getByIdentifier(routeSheetLocation.identifierChild).subscribe({
  //       next: async (data: EstatusJSON) => {
  //         if (data.isSuccess == true && data.result != null) {
  //           var routeGeoJson = data.result;
  //           if(!environment.production) console.log("related Data", routeGeoJson);
  //           this.setRouteToPoint(routeGeoJson);
  //           this.location_route_subscription.unsubscribe();
  //         }else{
  //           this.location_route_subscription.unsubscribe();
  //         }
  //       },
  //       error: (error) => {
  //         // TODO marca para complete despues
  //         console.error('Error al obtener detalles de locacion en routesheet', error);
  //         this.location_route_subscription.unsubscribe();
  //       }
  //     });
  //   }

  // setRouteToPoint(routeToPointGeoJson: string): void {
  //   if (routeToPointGeoJson != null && routeToPointGeoJson != "") {
  //     this.mapHelperService.UpdateLayerGeoJson( "routeToRouteSheetPointSource", JSON.parse(routeToPointGeoJson) );
  //     this.mapHelperService.MoveLayer("layer-RouteSheetRouteToPoint", "layer-RouteSheetRoute");
  //     this.mapHelperService.FitBounds( JSON.parse(routeToPointGeoJson).features[0].geometry );
  //   }
  // }

  // clearRouteToPointLayer(): void {
  //   if (this.location_route_subscription) {
  //     this.location_route_subscription.unsubscribe();
  //   }
  //   this.mapHelperService.UpdateLayerGeoJson("routeToRouteSheetPointSource", this.mapHelperService.Empty_GeoJson);
  // }

  isDynamicRouteSheet(locationCategory: LocationCategoryDTO): boolean {
    console.log("isDynamic", locationCategory);
    
    return (locationCategory?.name === EnumLocationCategories.Prospect || locationCategory?.isProspect);
  }

  isTicketRouteSheet(locationCategory: LocationCategoryDTO): boolean {
    return locationCategory?.name === EnumLocationCategories.Service;
  }

  isClusteredRouteSheet(locationCategory: LocationCategoryDTO): boolean {
    return this.isDynamicRouteSheet(locationCategory) || this.isTicketRouteSheet(locationCategory);
  }

  CreateLayers(locationCategory: LocationCategoryDTO): void {
    const sourceName = this.SourcePrefix + locationCategory.name;
    const layerNameServices = this.LayerPrefix + locationCategory.name;
    const layerTextName = layerNameServices + "-PinText";
    const layerNoOrderTextName = layerNameServices + "-NoOrderText";
    const layerClusterName = layerNameServices + "-Cluster";
    const layerClusterCountName = layerNameServices + "-ClusterCount";

    const routeSourceName = this.routeSourcePrefix + locationCategory.name;
    const routeLayerName = this.routeLayerPrefix + locationCategory.name;

    const descriptionLabel = this.isDynamicRouteSheet(locationCategory) ? "Title" : "IdentifierChild";
    if (!this.mapHelperService._map.getSource(sourceName)) {

      // this.mapHelperService.AddSourceEmptyGeoJson(sourceName, "Puntos de ruta - " + this.nameToSingularPipe.transform(locationCategory.name), locationCategory.icon);
      const singularName = this.nameToSingularPipe.transform(locationCategory.shortName);
      const isClustered = this.isClusteredRouteSheet(locationCategory);
      if (isClustered) {
        this.mapHelperService.AddSourceClusteredEmptyGeoJson(sourceName, singularName, locationCategory.icon, undefined, '', this.routeSheetClusterMaxZoom, this.routeSheetClusterRadius);
        this.mapHelperService.AddLayerCluster(layerClusterName, sourceName, "Clusters de " + singularName);
        this.mapHelperService.AddLayerClusterCount(layerClusterCountName, sourceName, "Conteo de clusters de " + singularName);
        this.mapHelperService.AddClusterZoomEvent(layerClusterName, sourceName);
      } else {
        this.mapHelperService.AddSourceEmptyGeoJson(sourceName, singularName, locationCategory.icon);
      }
      //su funcion de click es igual a location related, pero es exclusivo de route sheet
      this.mapHelperService.AddDirectionLine(routeLayerName, routeSourceName, "Ruta de " + this.nameToSingularPipe.transform(locationCategory.shortName));
      // this.mapHelperService.AddLayerLine("layer-RouteSheetRouteToPoint", "routeToRouteSheetPointSource", "Ruta punto actual al destino", "#354F84", 5);

      // para route sheet
      if (this.isTicketRouteSheet(locationCategory)) {
        this.mapHelperService.AddLayerText(layerTextName, sourceName, descriptionLabel, "Etiqueta de " + this.nameToSingularPipe.transform(locationCategory.name), 5);
        this.mapHelperService.AddLayerText(layerNoOrderTextName, sourceName, "NoOrder", "Etiqueta de orden de " + this.nameToSingularPipe.transform(locationCategory.name), -1.5, 0 , 18);
      }else{
        this.mapHelperService.AddLayerText(layerTextName, sourceName, descriptionLabel, "Etiqueta de " + this.nameToSingularPipe.transform(locationCategory.name), -2);
      }
      const allowOverlap = !isClustered;
      this.mapHelperService.AddLayerLocationsGeneral(layerNameServices, sourceName, "Icon", "Ubicaciones de " + this.nameToSingularPipe.transform(locationCategory.name), this.routeSheetMapIconSize, allowOverlap);

      this.addEvents(layerNameServices, layerNameServices);
    }
  }

  addEvents(sourceName: string, layerName: string) {
    var hoveredMarker = null;
    var hoveredMarkerFeature = null;
    var popup = new mapboxgl.Popup({});

    let currentPopup: mapboxgl.Popup = null;
    let popupTimeoutId: any = null;
    let isMouseNearPopup = false;

    const categoryPopUpMouseOver = (e) => {
      // por si hay un popup anterior a medio cerrar
      if (popupTimeoutId) {
        clearTimeout(popupTimeoutId);
        popupTimeoutId = null;
      }
      if (currentPopup) {
        currentPopup.remove();
        currentPopup = null;
      }

      // Obtener ID del marcador
      const marker = e.features[0];
      var layerName = "";
      if (
        e.features &&
        e.features[0] &&
        e.features[0].layer &&
        e.features[0].layer.id
      )
        layerName = e.features[0].layer.id;

      // Almacenar referencia al marcador
      hoveredMarker = marker;
      hoveredMarkerFeature = e.features[0];

      var categoryIcon = hoveredMarker.properties.Icon as string;
      var categoryActiveIcon = categoryIcon.replace(".png", "A.png");

      // Cambiar icono del marcador (el primer case es para encontrar el feature y el segundo para cambiar el icono), el segundo es del filtro
      this.mapHelperService._map.setLayoutProperty(layerName, "icon-image", [
        "case",
        ["==", ["get", "IdentifierChild"], marker.properties.IdentifierChild],
        categoryActiveIcon || categoryIcon,
        ["get", "Icon"],
      ]);

      const obj: any = e.features[0].properties;
      if (!environment.production) console.log("Objeto over", obj);

      const identifier: string = e.features[0].properties.IdentifierChild;
      const idLocationCategory: number = e.features[0].properties.IdLocationCategory;
      const description: string = e.features[0].properties.Description;
      const date: string = e.features[0].properties.CreatedIn;
      const name: string = e.features[0].properties.Title;
      const img: string = e.features[0].properties.Icon;
      const images = JSON.parse(this.localStorageService.getUrlMapList());
      const imgUrl = images.find((x) => x.name === img);

      // Crea el componente dinámicamente y pone estilo
      const componentRef: ComponentRef<CarouselComponent> = this.carouselViewContainerRef.createComponent(CarouselComponent);
      componentRef.instance.identifier = identifier;
      componentRef.instance.idLocationCategory = idLocationCategory;
      const carouselElement = componentRef.location.nativeElement;
      this.renderer.setStyle(carouselElement, "display", "flex");
      this.renderer.setStyle(carouselElement, "height", "100%");
      this.renderer.setStyle(carouselElement, "max-height", "120px");

      // Contenedor del popup
      const popupContainer = document.createElement("div");
      popupContainer.className = "popup-container";
      popupContainer.style.position = "relative";
      popupContainer.style.height = "auto";
      popupContainer.style.display = "flex";
      popupContainer.style.flexDirection = "column";
      popupContainer.style.justifyContent = "center";

      // para crear el carousel
      const carouselContainer = document.createElement("div");
      carouselContainer.style.width = "100%";
      // carouselContainer.style.minHeight = "15px";
      carouselContainer.style.maxHeight = "115px";
      carouselContainer.style.height = "auto";
      carouselContainer.style.overflow = "hidden";
      carouselContainer.style.position = "relative";
      // carouselContainer.style.marginTop = '8px';

      carouselContainer.appendChild(carouselElement);
      popupContainer.appendChild(carouselContainer);

      // Ttítulo con descripcion y clic
      const titleElement = document.createElement("h3");
      titleElement.innerText = description;
      titleElement.style.margin = "0 0 3px 10px";
      titleElement.style.color = "#3f51b5";
      titleElement.style.overflowX = "auto";
      titleElement.style.overflowY = "hidden";
      titleElement.style.maxHeight = "40px";
      titleElement.style.width = "90%";
      titleElement.style.whiteSpace = "nowrap";
      titleElement.addEventListener("mouseover", () => {
        titleElement.style.color = "#31ab45";
        titleElement.style.textDecoration = "underline";
        titleElement.style.cursor = "pointer";
      });
      titleElement.addEventListener("mouseleave", () => {
        titleElement.style.color = "#3f51b5";
        titleElement.style.textDecoration = "none";
      });
      var routeSheetLocationDTO = {
        identifierChild: identifier,
        idLocationCategory: idLocationCategory
      } as RouteSheetLocationDTO;
      titleElement.addEventListener("click", () => {
        this.openRouteSheetDetailsPopup(
          routeSheetLocationDTO,
          "",
          ""
        );
        this.mapHelperService.clearPopupEvents("images-popup-routeSheet");
      });
      popupContainer.appendChild(titleElement);

      // descripción flex padre
      const descriptionElement = document.createElement("div");
      descriptionElement.style.height = "50px";
      descriptionElement.style.margin = "0";
      descriptionElement.style.display = "flex";
      descriptionElement.style.flexDirection = "row";

      //imagen a la izquierda
      const descriptionImageElement = document.createElement("img");
      descriptionImageElement.style.width = "25%";
      descriptionImageElement.style.objectFit = "contain";
      descriptionImageElement.style.marginRight = "8px";
      // descriptionImageElement.style.borderRadius = '4px';
      descriptionImageElement.src = imgUrl?.url || "";
      descriptionElement.appendChild(descriptionImageElement);

      //flex con datos a la derecha
      const descriptionDataElement = document.createElement("div");
      descriptionDataElement.style.margin = "0";
      descriptionDataElement.style.display = "flex";
      descriptionDataElement.style.flexDirection = "column";
      descriptionElement.appendChild(descriptionDataElement);

      //titulo en los datos de la derecha
      const descriptionDataTitleElement = document.createElement("p");
      descriptionDataTitleElement.style.maxHeight = "25px";
      descriptionDataTitleElement.style.overflowX = "auto";
      descriptionDataTitleElement.style.overflowY = "hidden";
      descriptionDataTitleElement.style.margin = "0";
      descriptionDataTitleElement.style.whiteSpace = "nowrap";
      descriptionDataTitleElement.style.fontWeight = "bold";
      descriptionDataTitleElement.innerText = identifier;
      descriptionDataElement.appendChild(descriptionDataTitleElement);

      //fecha en los datos de la derecha
      const descriptionDataDateElement = document.createElement("p");
      descriptionDataDateElement.style.maxHeight = "25px";
      descriptionDataDateElement.style.overflowX = "hidden";
      descriptionDataDateElement.style.overflowY = "hidden";
      descriptionDataDateElement.style.margin = "0";
      descriptionDataDateElement.style.whiteSpace = "nowrap";
      descriptionDataDateElement.innerText = date;
      descriptionDataElement.appendChild(descriptionDataDateElement);

      //nombre en los datos de la derecha
      const descriptionDataNameElement = document.createElement("p");
      descriptionDataNameElement.style.maxHeight = "25px";
      descriptionDataNameElement.style.overflowX = "hidden";
      descriptionDataNameElement.style.overflowY = "hidden";
      descriptionDataNameElement.style.margin = "0";
      descriptionDataNameElement.style.whiteSpace = "nowrap";
      descriptionDataNameElement.style.fontWeight = "bold";
      descriptionDataNameElement.innerText = name;
      descriptionDataElement.appendChild(descriptionDataNameElement);

      popupContainer.appendChild(descriptionElement);

      // Crear y mostrar el popup
      currentPopup = new mapboxgl.Popup({
        closeButton: false,
        className: "images-popup-routeSheet",
        offset: [0, -25],
      }).setLngLat(e.lngLat)
        .setDOMContent(popupContainer)
        .addTo(this.mapHelperService._map);

      // agrego que acepte el mouse sobre el popup para que no se cierre al estar encima y un tieout para que no se cierre sin querer
      const popupElement = currentPopup.getElement();
      if (popupElement) {
        popupElement.addEventListener("mouseenter", () => {
          isMouseNearPopup = true;
          if (popupTimeoutId) {
            clearTimeout(popupTimeoutId);
            popupTimeoutId = null;
          }
        });

        popupElement.addEventListener("mouseleave", () => {
          isMouseNearPopup = false;
          popupTimeoutId = setTimeout(() => {
            categoryPopUpMouseLeave();
          }, 100);
        });
      }
    };

    const categoryPopUpMouseLeave = () => {
      if (isMouseNearPopup) {
        return;
      }

      popupTimeoutId = setTimeout(() => {
        if (hoveredMarker && !isMouseNearPopup) {
          if (!environment.production) console.log("hoveredMarkerId", hoveredMarker);
          var layerName = hoveredMarker.layer.id;
          // Cambiar icono del marcador
          this.mapHelperService._map.setLayoutProperty(layerName, "icon-image", [
            "get",
            "Icon",
          ]);
          this.mapHelperService._map.setPaintProperty(
            layerName + "-PinText",
            "text-color",
            "#530aa8"
          );

          hoveredMarker = null;
        }
        if (currentPopup) {
          currentPopup.remove();
          currentPopup = null;
        }
      }, 100);
    };

    const routeSheetMouseClick = (e) => {
      if (this.mapHelperService.isPointPickingActive) {
        return;
      }
      var routeSheetLocationDTO = {
        identifierChild: e.features[0].properties.IdentifierChild,
        idLocationCategory: e.features[0].properties.IdLocationCategory
      } as RouteSheetLocationDTO;

      this.openRouteSheetDetailsPopup(
        routeSheetLocationDTO,
        "",
        ""
      );
    };

    // Evento mouseenter
    this.mapHelperService.AddLayerEvent("mouseenter", layerName, categoryPopUpMouseOver);

    // Evento mouseleave
    this.mapHelperService.AddLayerEvent("mouseleave", layerName, categoryPopUpMouseLeave);

    // Evento click
    this.mapHelperService.AddLayerEvent("click", layerName, routeSheetMouseClick);
  }

  openRouteSheetDetailsPopup(routeSheetLocation: any, parentCoordX: string, parentCoordY: string) {
    if (this.dialogDetailsRef) {
      this.dialogDetailsRef.close();
      this.dialogDetailsRef = null;
    }
    var popupData = {
      identifierParent: routeSheetLocation.identifierParent,
      identifier: routeSheetLocation.identifierChild,
      parentCoordX: parentCoordX,
      parentCoordY: parentCoordY,
      FlyToOnOpen: true,
      FlyToParentOnClose: false
    };
    //el clasico trae idLocationCategory arriba; el dinamico lo trae dentro del virtualLocationDTO
    var idLocationCategory = routeSheetLocation?.idLocationCategory ?? routeSheetLocation?.virtualLocationDTO?.idLocationCategory;
    var category = JSON.parse(this.localStorageService.getListaCategorias()).find((category: any) => category.id == idLocationCategory);
    var categoryName = category?.name;
    if (!environment.production) console.log("categoryName", category, routeSheetLocation);

    //todo: si se ocupa cambiar los popups por algo independiente a "locations", copiar uno a la carpeta routesheet y adaptarlo a ser generico
    switch (categoryName){
      case EnumLocationCategories.Service:
        this.dialogDetailsRef = this.dialog.open(ServiceLocationDetailPopupComponent,
          {
            maxWidth: "98vw",
            maxHeight: "92vh",
            autoFocus: false,
            restoreFocus: false,
            hasBackdrop: false,
            disableClose: true,
            data: { ...popupData, UpdateActiveLayer: true },
          }
        );
        break;
      case EnumLocationCategories.Location:
        this.dialogDetailsRef = this.dialog.open(LocationsLocationDetailPopupComponent,
          {
            maxWidth: "98vw",
            maxHeight: "92vh",
            autoFocus: false,
            restoreFocus: false,
            hasBackdrop: false,
            disableClose: true,
            data: popupData,
          }
        );
        break;
      case EnumLocationCategories.Prospect:
        this.dialogDetailsRef = this.dialog.open(ProspectDetailsPopupComponent,
          {
            maxWidth: "98vw",
            maxHeight: "92vh",
            autoFocus: false,
            restoreFocus: false,
            hasBackdrop: false,
            disableClose: true,
            data: { ...popupData, UpdateActiveLayer: true },
          }
        );
        break;
      default:
        this.dialogDetailsRef = this.dialog.open(GeneralLocationsDetailsPopUpComponent,
          {
            maxWidth: "98vw",
            maxHeight: "92vh",
            autoFocus: false,
            restoreFocus: false,
            hasBackdrop: false,
            disableClose: true,
            data: popupData,
          }
        );
    }

    //añade el z-index al contenedor del overlay para que esté debajo del nav
    const overlayContainer = document.querySelector(".cdk-overlay-container") as HTMLElement;
    if (overlayContainer) {
      overlayContainer.style.zIndex = "4";
    }

    this.dialogDetailsRef.afterClosed().subscribe((result) => {
      if (!environment.production) console.log("cerrado");
      this.dialogDetailsRef = null;
      if (this.location_details_subscription)
        this.location_details_subscription.unsubscribe();
      //quita el z-index del contenedor del overlay
      const overlayContainer = document.querySelector(".cdk-overlay-container") as HTMLElement;
      if (overlayContainer) {
        overlayContainer.style.removeProperty("z-index");
      }
    });

  }

  async setRouteSheetLayers(routeGeoJson: string, locationGeoJson: string, parentCategory: LocationCategoryDTO, childCategory: LocationCategoryDTO): Promise<void> {
    if (routeGeoJson != null && routeGeoJson != "") {
      const geoJson = JSON.parse(routeGeoJson);
      var parentSingularName = this.nameToSingularPipe.transform(parentCategory.shortName);
      const coordinates = geoJson.features[0].geometry.coordinates;

      await this.mapHelperService.AddMapMatchedRoute("routeSheetRouteSource-" + childCategory.name, coordinates);
      //this.generatedLayerService.createLayer(parentSingularName, "Ruta de " + childCategory.shortName, ["routeSheetRouteSource-" + childCategory.name, "routeSheetRouteSource-" + childCategory.name + "-Start", "routeSheetRouteSource-" + childCategory.name + "-End", "routeSheetRouteSource-" + childCategory.name + "-Dialog"], true);
      // this.mapHelperService.UpdateLayerGeoJson( "routeSheetRouteSource", geoJson );

      this.loadedLocationCategories[childCategory.name] = childCategory;
    }

    if (locationGeoJson != null && locationGeoJson != "") {
      var parentSingularName = this.nameToSingularPipe.transform(parentCategory.shortName);
      const geoJson = JSON.parse(locationGeoJson);
      this.mapHelperService.UpdateLayerGeoJson("routeSheetLocationsSource-" + childCategory.name, geoJson);
      this.mapHelperService.SetBounds(geoJson);

      if (routeGeoJson != null && routeGeoJson != "") {
        this.moveRouteLayers("layer-RouteSheetRoute-" + childCategory.name, "layer-RouteSheetLocations-" + childCategory.name, true);
        this.mapHelperService.MoveLayer("layer-RouteSheetLocations-" + childCategory.name + "-PinText", "layer-RouteSheetLocations-" + childCategory.name);
        if (this.isTicketRouteSheet(childCategory)) {
          this.mapHelperService.MoveLayer("layer-RouteSheetLocations-" + childCategory.name + "-NoOrderText", "layer-RouteSheetLocations-" + childCategory.name);
        }
      } else {
        this.mapHelperService.MoveLayer("layer-RouteSheetLocations-" + childCategory.name, "layer-location" + childCategory.name + "Active");
        this.mapHelperService.MoveLayer("layer-RouteSheetLocations-" + childCategory.name, "layer-location" + childCategory.name + "Active");
        this.mapHelperService.MoveLayer("layer-RouteSheetLocations-" + childCategory.name + "-PinText", "layer-RouteSheetLocations-" + childCategory.name);
        if (this.isTicketRouteSheet(childCategory)) {
          this.mapHelperService.MoveLayer("layer-RouteSheetLocations-" + childCategory.name + "-NoOrderText", "layer-RouteSheetLocations-" + childCategory.name);
        }
      }

      //this.generatedLayerService.createLayer(parentSingularName, childCategory.shortName, ["routeSheetLocationsSource-" + childCategory.name], true);

      this.loadedLocationCategories[childCategory.name] = childCategory;
    }
  }

  clearRouteSheetLayers(parentCategoryName: string): void {
    Object.keys(this.loadedLocationCategories).forEach(categoryKey => {
      var locationCategory = this.loadedLocationCategories[categoryKey];
      this.clearRouteSheetLayer(parentCategoryName, locationCategory);
      delete this.loadedLocationCategories[categoryKey];
    });
    this.mapHelperService.clearPopupEvents("images-popup-routeSheet");
  }

private clearRouteSheetLayer (parentCategoryName: string, locationCategory: LocationCategoryDTO): void {
  const sourceName = this.SourcePrefix + locationCategory.name;
  const routeSourceName = this.routeSourcePrefix + locationCategory.name;

  var parentSingularName = this.nameToSingularPipe.transform(parentCategoryName);
  this.mapHelperService.UpdateLayerGeoJson(sourceName, this.mapHelperService.Empty_GeoJson);
  if (!environment.production) console.log("eliminando layer de: " + locationCategory.name, "parentSingularName: ", parentSingularName, "categoryShortName: ", locationCategory.shortName);

  //this.generatedLayerService.deleteLayer(parentSingularName, locationCategory.shortName);

  this.mapHelperService.UpdateLayerGeoJson(routeSourceName, this.mapHelperService.Empty_GeoJson);
  this.mapHelperService.UpdateLayerGeoJson(routeSourceName + "-Start", this.mapHelperService.Empty_GeoJson);
  this.mapHelperService.UpdateLayerGeoJson(routeSourceName + "-End", this.mapHelperService.Empty_GeoJson);
  this.mapHelperService.UpdateLayerGeoJson(routeSourceName + "-Dialog", this.mapHelperService.Empty_GeoJson);
  //this.generatedLayerService.deleteLayer(parentSingularName, "Ruta de " + locationCategory.shortName);
}

  private moveRouteLayers(routeLayer: string, layerId: string, sendToTop: boolean): void {
    if (sendToTop) {
      this.mapHelperService.MoveLayerToTop(layerId);
    }

    this.mapHelperService.MoveLayer(routeLayer + "-background", layerId);
    this.mapHelperService.MoveLayer(routeLayer, layerId);
    this.mapHelperService.MoveLayer(routeLayer + "-arrows", layerId);
    this.mapHelperService.MoveLayer(routeLayer + "-dialog", layerId);
    this.mapHelperService.MoveLayer(routeLayer + "-dialog-text", layerId);
    this.mapHelperService.MoveLayer(routeLayer + "-start-pin-pulse", layerId);
    this.mapHelperService.MoveLayer(routeLayer + "-start-pin", layerId);
    this.mapHelperService.MoveLayer(routeLayer + "-end-pin", layerId);
    this.mapHelperService.MoveLayer(routeLayer + "-label", layerId);
    this.mapHelperService.MoveLayer(layerId, routeLayer + "-dialog");
  }
}
